<template>
    <div class="d-flex flex-column setMaxWidthOfChildren align-items-center text-left mb-5 mt-2">
        <h3 class="my-2">{{ $t('recoveruser.step1.header') }}</h3>
        <h5 class="my-2">{{ $t('recoveruser.step1.subHeader') }}</h5>
        <p>
            {{ $t('recoveruser.step1.description') }}
        </p>

        <SocialAuthBtns style="margin: 0 !important;" :redirectPath="redirectPath" />

        <h6 class="my-4 text-center">{{ $t('recoveruser.step1.OR') }}</h6>

        <BaseButton @click="nextPage" variant="primary" class=" py-2">{{
            $t('recoveruser.step1.emailAndPassword')
        }}</BaseButton>
    </div>
</template>

<script>
// Components
import SocialAuthBtns from '~/shared/loginmodule/components/SocialAuthBtns/SocialAuthBtns';

export default {
    name: 'Step1',
    components: {
        SocialAuthBtns,
    },

    props: {
        redirectPath: String, // The redirect path for external providers
    },
    methods: {
        nextPage() {
            this.$emit('nextpage');
        },
    },
};
</script>

<style scoped>
.animation-enter-active,
.animation-leave-active {
    transition: opacity 1s ease, transform 0.5s ease;
    opacity: 1;
    transform: translateX(0);
}
.animation-enter,
.animation-leave-to {
    transition: all 0.5s ease;
    opacity: 0;
}
.animation-enter {
    transform: translateX(50px);
}
.animation-leave-to {
    transform: translateX(-50px);
}
</style>
